<template>
    <EidIcon :icon-src="lockImg" alt="lock-icon" />
</template>

<script lang="ts">
    import EidIcon from '../EidIcon/EidIcon.vue';

    import lockImg from './lock-icon.svg';

    export default {
        name: 'LockInputIcon',
        components: {
            EidIcon,
        },
        data() {
            return { lockImg };
        },
    };
</script>
